// =========================================================
// * Vue Material Kit - v1.2.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-kit
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-kit/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

const axios = require('axios').default
import Vue from "vue"
import Vuex from 'vuex'
import App from "./App.vue"
import router from "./router"

import MaterialKit from "./plugins/material-kit"


// Import component of loading
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Init plugin
Vue.use(Loading)
// end of component loading

// import Constants
import Constants from "@/plugins/Constants"
Vue.use(Constants)

// import global methods
import GlobalMethods from "@/plugins/globalMethods"
Vue.use(GlobalMethods)

// notification
import Notifications from 'vue-notification'
Vue.use(Notifications)


Vue.config.productionTip = false

Vue.use(MaterialKit)
Vue.use(Vuex)

const NavbarStore = {
  showNavbar: false
}

Vue.mixin({
  data() {
    return {
      NavbarStore
    }
  }
})

const store = new Vuex.Store({
  state: {
    refreshToken: '',
    accessToken: '',
    user: {}
  },
  mutations: {
    // increment (state) {
    //   state.count++
    // },
    initialiseStore(state) {
			if(localStorage.getItem(Vue.Constants.KEY_LS_LINE_REFRESH_TOKEN)) {
        state.refreshToken = localStorage.getItem(Vue.Constants.KEY_LS_LINE_REFRESH_TOKEN)
      }
      if(localStorage.getItem(Vue.Constants.KEY_LS_LINE_ACCESS_TOKEN)) {
        state.accessToken = localStorage.getItem(Vue.Constants.KEY_LS_LINE_ACCESS_TOKEN)
			}
		},
    setRefreshToken (state, payload) {
      state.refreshToken = payload
    },
    setAccessToken (state, payload) {
      state.accessToken = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    clearUserData(state) {
      state.refreshToken = ''
      state.accessToken = ''
      state.user = {}
    }
  }
})

store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
  localStorage.setItem(Vue.Constants.KEY_LS_LINE_REFRESH_TOKEN, state.refreshToken)
  localStorage.setItem(Vue.Constants.KEY_LS_LINE_ACCESS_TOKEN, state.accessToken)
})

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit('initialiseStore')
	},
  created: function() {
    window.addEventListener('beforeunload', this.handlerClose)

    this.fetchProfile()
  },
  computed: {
    isSignedIn() {
      let refreshToken = this.$store.state.refreshToken
      let accessToken = this.$store.state.accessToken

      if (!refreshToken || !accessToken) {
        return false
      }

      return true
    }
  },
  methods: {
    // Callback handler
    handlerClose: function() {
      // localStorage.removeItem('lineState')
      // localStorage.removeItem('lineNonce')
      // localStorage.clear()
    },
    isEmptyObject(obj) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          return false;
        }
      }
      return true;
    },
    fetchProfile() {
      let user = this.$store.state.user
      if (this.isSignedIn && this.isEmptyObject(user)) {
        let vm = this
        let headers = {}
        headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + this.$store.state.accessToken
        headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
        axios.get(Vue.Constants.BADMINTON_API_URL + 'users/profile', {headers: headers}).then(function (response) {

          vm.$store.commit('setUser', response.data.data.user)
        }).catch(function (error) {
          if (error.response.status) {
            // refresh access token
            const params = new URLSearchParams()
            params.append('grant_type', 'refresh_token')
            params.append('refresh_token', vm.$store.state.refreshToken)
            params.append('client_id', Vue.Constants.LINE_CLIENT_ID)
            params.append('client_secret', Vue.Constants.LINE_SECRET)
            axios.post('https://api.line.me/oauth2/v2.1/token', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function (response) {

              let accessToken = response.data.access_token
              let refreshToken = response.data.refresh_token

              vm.$store.commit('setRefreshToken', refreshToken)
              vm.$store.commit('setAccessToken', accessToken)

              let headers = {}
              headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + accessToken
              headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
              axios.get(Vue.Constants.BADMINTON_API_URL + 'users/profile', {headers: headers}).then(function (response) {
                vm.$store.commit('setUser', response.data.data.user)
              }).catch(function (error) {
              })
            }).catch(function (error) {
            })
          }
        })
      }
    }
  },
  render: h => h(App)
}).$mount("#app")
